import styled from 'styled-components';

import { BODY_TEXT_TERTIARY } from 'styles/color';
import { FONT_WEIGHT_REGULAR } from 'styles/tokens';

import Text from './Text';

const TertiaryText = styled(Text)`
  color: ${BODY_TEXT_TERTIARY};
  font-weight: ${FONT_WEIGHT_REGULAR};
`;

export default TertiaryText;
